(() => {
  const init = (section) => {
    const container = section.querySelector(
      ".collections-list-swiper__container"
    );
    if (!container || container.swiper) return;

    const wrapper = section.querySelector(".collections-list-swiper__slides");
    const slides = section.querySelectorAll(".collections-list-swiper__slide");
    if (!wrapper || !slides.length) return;

    container.classList.add("swiper");
    wrapper.classList.add("swiper-wrapper");
    slides.forEach((s) => s.classList.add("swiper-slide"));

    const columns = Number(section.dataset.columnsPerRow || 3);
    const breakpoints = {
      2: {
        576: { slidesPerView: 2 },
      },
      3: {
        576: { slidesPerView: 2 },
        990: { slidesPerView: 3 },
      },
      4: {
        576: { slidesPerView: 2 },
        990: { slidesPerView: 3 },
        1200: { slidesPerView: 4 },
      },
    };

    new Swiper(container, {
      slidesPerView: 1,
      spaceBetween: 20,
      watchOverflow: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: section.querySelector(".collections-list-swiper__button--next"),
        prevEl: section.querySelector(".collections-list-swiper__button--prev"),
      },
      pagination: {
        el: section.querySelector(".collections-list-swiper__pagination"),
        clickable: true,
      },
      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 8 }, // mobile
        ...breakpoints[columns],
      },
    });
  };

  const initCollectionSection = () =>
    document.querySelectorAll(".collections-list-swiper").forEach(init);

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", initCollectionSection)
    : initCollectionSection();

  document.addEventListener("shopify:section:load", (e) =>
    initCollectionSection(e.target)
  );
})();
